import { Button, Box, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./RecordNavbar.module.scss";
import { RecordNavbarProps } from "../../interface";

/**
 * RecordNavbar component renders a search bar along with action buttons
 * for exporting data and generating sample summaries.
 *
 * @component
 * @param {Object} props
 * @param {string} props.searchData - Current value of the search input.
 * @param {Object} props.disabled - disable action buttons.
 * @param {Function} props.handleGenerateSummary - Callback to trigger sample generation.
 * @param {Function} props.handleExportClick - Callback to trigger data export.
 * @param {Function} props.onSearchChange - Callback when the search input changes.
 */
const RecordNavbar = ({
  searchData,
  disabled,
  handleGenerateSummary,
  handleExportClick,
  onSearchChange,
  onSearchSubmit,
}: RecordNavbarProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      onSearchSubmit();
    }
  };

  return (
    <Box className={styles.container}>
      <TextField
        placeholder="Search..."
        variant="outlined"
        size="small"
        className={styles.searchBar}
        InputProps={{
          startAdornment: <SearchIcon className="search-icon" />,
        }}
        data-testid="search-bar"
        value={searchData}
        onChange={(e) => onSearchChange(e.target.value)}
        onKeyDown={handleKeyDown}
        autoComplete="off"
      />
      <Button
        variant="contained"
        className={styles.actionBtn}
        onClick={onSearchSubmit}
        data-testid="search-button"
      >
        Search
      </Button>
      <Box className={styles.actions}>
        <Button
          variant="outlined"
          className={styles.actionBtn}
          onClick={handleExportClick}
          disabled={disabled.export}
          data-testid="export-button"
        >
          Export list
        </Button>
        <Button
          variant="contained"
          className={styles.actionBtn}
          disabled={disabled.generate}
          data-testid="generate-button"
          onClick={handleGenerateSummary}
        >
          Generate sample
        </Button>
      </Box>
    </Box>
  );
};

export default RecordNavbar;
